import { MixedSchema } from 'yup/lib/mixed';

export default function fileSize(this: MixedSchema, size: number) {
  const message = `Arquivo tem que ter no máximo ${size}MB`;

  return this.test('fileSize', message, (value: File) => {
    const ONE_MEGABYTE_IN_BYTES = 1000000;
    const maxedSize = size * ONE_MEGABYTE_IN_BYTES;
    return value?.size < maxedSize;
  });
}
